export default "__VITE_ASSET__JZCiXrAU__"